import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import MarginCalculator from './MarginCalculator';

const MarginInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Margin Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Margin Calculator helps traders understand the margin requirements and leverage available for different types of trades. It calculates the required margin, maximum exposure, and potential risk, helping you make informed trading decisions and manage your trading capital effectively.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Trade Value</li>
        <li>Margin Percentage</li>
        <li>Maximum Exposure</li>
        <li>Risk per Trade</li>
        <li>Leverage Ratio</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses the following formulas to determine margin requirements:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Required Margin = Trade Value × Margin Percentage</li>
        <li>Leverage = 1 / Margin Percentage</li>
        <li>Maximum Exposure = Trade Value × Leverage</li>
        <li>Risk per Trade = Required Margin × Risk Percentage</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculate exact margin requirements</li>
        <li>Understand leverage limits</li>
        <li>Manage trading capital</li>
        <li>Assess risk exposure</li>
        <li>Make informed trading decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your trade value and margin percentage to calculate the required margin and other trading parameters. The calculator will provide a comprehensive view of your trading capital requirements and risk exposure, helping you make informed trading decisions.</p>
    </div>
  );
};

const Margin = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <MarginCalculator/>
        </div>
        <MarginInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Margin;